/* ============================================================================
   rcds-last-collection.js — "Continue shopping" returns you where you were.

   WHY THIS EXISTS
   The quote-cart heading links to a hardcoded /collections/all
   (sections/rcds-cart.liquid), so a customer browsing 33 inch drawer systems
   who opened their quote got dumped into the full catalogue. Sophia flagged it
   2026-08-10: "can we please update the Continue Shopping button so it takes
   the customer back to the collection/category they were previously shopping
   in, rather than back to All Products?"

   WHY NOT LIQUID
   /cart is a server-rendered page (templates/cart.json -> rcds-cart), so the
   `collection` global is nil there. The PDP cannot supply it either: collection
   grids link to bare /products/<handle>, never /collections/x/products/y, so
   `collection` is nil on the product page too. The browser has to carry it.

   WHY sessionStorage, NOT localStorage
   "Previously shopping in" is a within-visit idea. A tab-scoped store cannot go
   stale across visits, so there is no TTL to tune and no risk of sending someone
   to a collection they last saw days ago.

   SECURITY — the stored value is UNTRUSTED INPUT
   Anything in sessionStorage can be edited by the user or by any script that
   runs on the origin. Assigning it straight to href would accept a
   `javascript:` URI. So the reader re-validates against a strict
   /collections/<handle> shape before it touches href, and sets the label with
   textContent, never innerHTML.

   PROGRESSIVE ENHANCEMENT
   The anchor keeps its real /collections/all href in the markup. No JS, a first
   visit that lands straight on /cart, or a storage throw in private mode all
   behave exactly as before. This can never produce a dead or hostile link.
   ============================================================================ */
(function () {
  var KEY = 'rcds_last_collection';

  // Only ever trust this exact shape. Shopify handles are lowercase
  // alphanumeric plus hyphens; no query, no fragment, no scheme, no path depth.
  var SAFE_COLLECTION_URL = /^\/collections\/[a-z0-9][a-z0-9-]*$/;

  // Private mode / disabled storage throws on access. Never break the page.
  function read() {
    try { return JSON.parse(window.sessionStorage.getItem(KEY) || 'null'); }
    catch (e) { return null; }
  }

  // WRITER: called from the collection page with real Liquid values.
  window.rcdsRecordCollection = function (url, title) {
    if (!SAFE_COLLECTION_URL.test(url || '')) { return; }
    // Never record the catch-alls: returning to them is the thing being fixed.
    if (url === '/collections/all' || url === '/collections/all-products') { return; }
    try {
      window.sessionStorage.setItem(KEY, JSON.stringify({ url: url, title: title || '' }));
    } catch (e) { /* quota or blocked — the fallback href covers us */ }
  };

  // READER: repoint the cart's Continue shopping link.
  function applyToCart() {
    var a = document.querySelector('.rcds-cart__continue');
    if (!a) { return; }

    var rec = read();
    if (!rec || typeof rec.url !== 'string') { return; }
    // Re-validate on READ. The write-side check is not enough: storage is
    // writable by anything on the origin, so this is the gate that matters.
    if (!SAFE_COLLECTION_URL.test(rec.url)) { return; }

    a.setAttribute('href', rec.url);

    // Swap only the words, so the &larr; in the markup survives.
    var label = a.querySelector('[data-rcds-continue-label]');
    if (label && typeof rec.title === 'string' && rec.title) {
      label.textContent = 'Back to ' + rec.title;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyToCart);
  } else {
    applyToCart();
  }
})();
